import styled from 'styled-components';
import { Button as SonarButton, Icon } from '@appcues/sonar';

const PanelContainer = styled.details`
  padding: var(--spacing-small) var(--spacing-regular);
  background-color: var(--background-app);
  border: var(--border-width-x-small) solid var(--border-default);
  border-radius: var(--border-radius-small);
  font-size: var(--regular);
`;

const PanelSummary = styled.summary`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-small);
  padding: var(--spacing-x-small) 0;
  font-weight: var(--bold);
  cursor: pointer;
  list-style: none;
`;

const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  padding-top: var(--spacing-small);
  color: var(--foreground-secondary);
`;

export const Panel = {
  Container: PanelContainer,
  Summary: PanelSummary,
  Content: PanelContent,
};

export const Counter = styled.span`
  display: inline-block;
  background-color: var(--foreground-primary);
  color: var(--foreground-inverse);
  border-radius: var(--border-radius-large);
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 11px;
  text-align: center;
`;

export const Title = styled.span`
  flex: 1;
`;

export const RotatingIcon = styled(Icon)`
  transition: transform 200ms cubic-bezier(0.87, 0, 0.13, 1);
  [open] & {
    transform: rotate(-180deg);
  }
`;

const OverrideList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`;

const OverrideRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-small);
  font-weight: var(--bold);
`;

const OverrideProperty = styled.span`
  flex: 1;
`;

const OverridePropertyLocales = styled.span`
  display: block;
  font-weight: var(--regular);
  color: var(--foreground-tertiary);
  font-size: var(--font-size-small);
`;

const OverrideResetButton = styled(SonarButton)`
  height: auto;
`;

export const Overrides = {
  List: OverrideList,
  Row: OverrideRow,
  Property: OverrideProperty,
  PropertyLocales: OverridePropertyLocales,
  ResetButton: OverrideResetButton,
};

export const SplitButton = styled.div`
  display: flex;

  ${SonarButton} {
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right-width: 0;
    }

    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`;

export const ItemDescription = styled.div`
  cursor: default;
  color: var(--foreground-secondary);
  font-size: var(--font-size-small);
`;
